export default "__VITE_ASSET__i6qiOwbi__"